var _rect, _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogolanding(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 42,
    viewBox: "0 0 44 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 8.81226,
    width: 33.1877,
    height: 33.1877,
    rx: 4.42502,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.199 27.2017C23.5804 26.4035 23.5804 24.4089 22.199 23.6099L15.1424 19.5303C13.7602 18.7313 12.0303 19.7295 12.0303 21.3266V29.4858C12.0303 31.083 13.7602 32.0811 15.1424 31.2813L22.199 27.2017Z",
    fill: "#5960D5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.104 9.43339L25.3599 10.1251L25.104 9.43339C23.6593 9.96798 23.6593 12.0113 25.104 12.5459L28.9697 13.9763C29.0202 13.995 29.06 14.0348 29.0786 14.0853L30.5091 17.951C31.0437 19.3957 33.087 19.3957 33.6216 17.951L35.052 14.0853C35.0707 14.0348 35.1105 13.995 35.161 13.9763L39.0267 12.5459C40.4713 12.0113 40.4714 9.96798 39.0267 9.43339L35.161 8.00296C35.1105 7.98428 35.0707 7.94449 35.052 7.89402L33.6216 4.02832C33.087 2.58364 31.0437 2.58363 30.5091 4.02832L29.0786 7.89402C29.06 7.94449 29.0202 7.98428 28.9697 8.00295L25.104 9.43339Z",
    fill: "white",
    stroke: "url(#paint0_linear_950_667)",
    strokeWidth: 1.47501
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0379 0.934603C39.1567 0.613561 39.6108 0.613562 39.7296 0.934604L40.3589 2.63547C40.3963 2.73641 40.4759 2.81599 40.5768 2.85333L42.2777 3.48271C42.5987 3.60151 42.5987 4.05559 42.2777 4.17438L40.5768 4.80376C40.4759 4.84111 40.3963 4.92069 40.3589 5.02162L39.7296 6.72249C39.6108 7.04353 39.1567 7.04353 39.0379 6.72249L38.4085 5.02162C38.3712 4.92069 38.2916 4.84111 38.1906 4.80376L36.4898 4.17438C36.1687 4.05558 36.1687 3.60151 36.4898 3.48271L38.1906 2.85333C38.2916 2.81599 38.3712 2.73641 38.4085 2.63547L39.0379 0.934603Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_950_667",
    x1: 32.0653,
    y1: 1.94775,
    x2: 32.0653,
    y2: 20.0315,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F56D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B5ED5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogolanding);
export default __webpack_public_path__ + "static/media/logolanding.f8d37f6fdc25b7a328347dccc16ec8a8.svg";
export { ForwardRef as ReactComponent };